import React from "react";
import ReactDOM from "react-dom";
import 'antd/dist/antd.variable.min.css'
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
//redux
import allReducers from "./global-state/reducers/allReducers";
import { applyMiddleware, createStore } from "redux";
import thunk from "redux-thunk";
import { Provider } from "react-redux";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import promiseMiddleware from "redux-promise";
import { saveState, loadState } from "./global-state/LocalStorage";
import "./resourses/Localization";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/font-awesome/css/font-awesome.min.css";
import "../node_modules/@fortawesome/fontawesome-svg-core/styles.css";

const persistedState = loadState();
const middleware = [thunk];
const store = createStore(
  allReducers,
  persistedState,
  composeWithDevTools(applyMiddleware(promiseMiddleware, ...middleware))
);

store.subscribe(() => {
  saveState({
    auth: store.getState().auth,
  });
});

// Sentry.init({
//   dsn: "https://fa46aa1beccd4d30bd2427bafdcd1578@o1252202.ingest.sentry.io/6418211",
//   integrations: [new BrowserTracing()],

//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0,
// });

ReactDOM.render(
  <React.StrictMode>
    {/* <Suspense fallback="loading"> */}
    <Provider store={store}>
      <App />
    </Provider>
    {/* </Suspense> */}
  </React.StrictMode>,
  document.getElementById("root")
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
